import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://szyxqyybdnbdgskardwp.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN6eXhxeXliZG5iZGdza2FyZHdwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ5OTg2MzYsImV4cCI6MjA3MDU3NDYzNn0.LwUSvpMCouDJ9QhvhD5pY5PZK32l7PXrSCG8gkIgclo";

// Normal kullanıcı işlemleri için client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});
